// Components
import BackButton from "@/components/UI/BackButton/BackButton";

// Utils
import st from "./index.module.scss";

type PageTitleProps = {
  title?: string;
  titleSecond?: string;
  isBackButton?: boolean;
};

export default function PageHeader({ title, titleSecond, isBackButton }: PageTitleProps) {
  return (
    <div className={st.header}>
      {isBackButton && <BackButton />}
      <h2 className={st.title}>{title}</h2>
      {titleSecond && <h3>{titleSecond}</h3>}
    </div>
  );
}
